enum EmployeeVacationRequestType {
    Vacation = 0,
    SpecialLeave = 1
}

export default EmployeeVacationRequestType;